var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "small-company") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABmJLR0QA/wD/AP+gvaeTAAAAxUlEQVQ4jc2T4Q2CMBCFP43/XcAJCnOwAe6BC4gLuAgbsEddwA1cAP+8xtKUliaY8JJL3+Ued68pB3vHQacBrhltX9K4BaZMrMIxyG9ALT6KjyXOTgXaKlN/Ax+XrLlyLtqYwwF4AXedg4QGeCw4M66ZD+fQFSY1c0NSjzL7NnyUJ2DFG/FGuVU91M0QNtwMf7tyy28jjLhR3nsDfV1ySi5irpMOU5tSA5145+lmKNkUgLPCoQIuMeHmm2JZ3oS1iP6X+8MXWt5dVkOnyZcAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCompany);
export default __webpack_public_path__ + "static/media/small-company.643aee77.svg";
export { ForwardRef as ReactComponent };